import { useRef } from 'react';

export const useAwsWafTokenRef = () => {
  return useRef<() => Promise<string>>(() => Promise.resolve(''));
};
